import { createContext, useContext } from 'react';
import type { Batch } from '../types';

export type BatchContextValue = {
  batches: Batch[];
  setBatches: React.Dispatch<React.SetStateAction<Batch[]>>;
  batchId: string;
  setBatchId: React.Dispatch<React.SetStateAction<string>>;
  selectedBatch: Batch | null;
  refreshBatches: () => Promise<void>;
};

export const BatchContext = createContext<BatchContextValue | null>(null);

export function useBatch(): BatchContextValue {
    const ctx = useContext(BatchContext);
    if (!ctx) throw new Error('useBatch must be used within a BatchProvider');
    return ctx;
}
